import React, { useState, useEffect } from 'react';
import { getFromContext } from '../../AlertFiltersContext';

export const AlertJobCount = () => {
  const { state, dispatch } = getFromContext();
  const { prefix, facets, editing } = state;
  const [jobCount, setJobCount] = useState(null);
  const [searchUrl, setSearchUrl] = useState('/jobs/search?');

  const getJobCount = async () => {
    const qs = [
      ...facets.map((facet) => facet.queryStringId),
      `siteCountry=${state.i18n.country || 'gb'}`,
    ].join('&');

    if (qs) {
      setSearchUrl(`/jobs/search?${qs}`);
      try {
        const response = await fetch(`/api/jobs/count?${qs}`);
        const { count } = await response.json();

        setJobCount(count);

        dispatch({
          type: 'job-count',
          value: count,
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    }
  };

  useEffect(() => {
    getJobCount();
  }, [facets]);

  return (
    <>
      {jobCount > 0 ? (
        <p className={`${prefix}__job-count ${prefix}__job-count--matched`}>
          {editing ? (
            <>
              <span>{jobCount}</span>
              <span>jobs match your job alert filters</span>
            </>
          ) : (
            <a href={searchUrl} style={{ marginLeft: 'auto' }}>
              View {jobCount} matching jobs
              <i className="tds-icon icon--tds-chevron-right" />
            </a>
          )}
        </p>
      ) : (
        <p className={` ${prefix}__job-count ${prefix}__job-count--not-matched`}>
          There are currently no jobs matching these filters. <br />
          We will email you as soon as we have matching jobs.
        </p>
      )}
    </>
  );
};
